<template>
  <div>
    <NJNav></NJNav>
    <div class="wheatWrap">
      <ul class="wheatTab">
        <li v-for="(item, index) in wheatTab" :key="index" @click="tabOn(index, item)"
          :class="active == index ? 'active' : ''">
          <img :src="item.img" />
          <span>{{ item.name }}</span>
        </li>
      </ul>
      <div class="wheatContent">
        <Progress v-if="active == 0"></Progress>
        <AreaProgress v-else-if="active == 1"></AreaProgress>
        <Trend v-else-if="active == 2"></Trend>
        <Today v-else-if="active == 3"></Today>
        <Dispatch v-else></Dispatch>



      </div>
    </div>
  </div>
</template>

<script>
import "echarts/map/js/china.js"
import Api from "../../Serves/net-api.js";
import Http from "../../Serves/net-http.js";
import Progress from "./progress";
import AreaProgress from "./areaProgress";
import Trend from "./trend";
import Today from "./today";
import Dispatch from "./dispatch";




import NJNav from '../Index/view/NJNav'
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  name: "ToolStatistics",
  components: {
    NJNav,
    Progress,
    AreaProgress,
    Trend,
    Today,
    Dispatch

  },
  data() {
    return {
      wheatTab: [{
        name: '麦收进度图',
        imgObj: require('@/assets/img/ms/progress_title_icon01.png'),
        img: require('@/assets/img/ms/progress_on_title_icon01.png'),
        imgOn: require('@/assets/img/ms/progress_on_title_icon01.png')

      }, {
        name: '各地区麦收进度',
        imgObj: require('@/assets/img/ms/progress_title_icon02.png'),
        img: require('@/assets/img/ms/progress_title_icon02.png'),
        imgOn: require('@/assets/img/ms/progress_on_title_icon02.png')
      }, {
        name: '麦收趋势图',
        imgObj: require('@/assets/img/ms/progress_title_icon03.png'),
        img: require('@/assets/img/ms/progress_title_icon03.png'),

        imgOn: require('@/assets/img/ms/progress_on_title_icon03.png')
      }, {
        name: '今日麦收农机',
        imgObj: require('@/assets/img/ms/progress_title_icon04.png'),
        img: require('@/assets/img/ms/progress_title_icon04.png'),

        imgOn: require('@/assets/img/ms/progress_on_title_icon04.png')
      }, {
        name: '麦收调度',
        imgObj: require('@/assets/img/ms/progress_title_icon05.png'),
        img: require('@/assets/img/ms/progress_title_icon05.png'),
        imgOn: require('@/assets/img/ms/progress_on_title_icon05.png')
      }],
      active: 0
    }
  },

  mounted() {


  },

  methods: {
    tabOn(index, item) {
      // if(index==2){
      //   this.$message({
			// 		showClose: true,
			// 		message: '功能尚未开发，敬请期待~',
			// 		type: 'warning'
			// 	})
      //   return false;
      // }
      this.active = index;
      this.wheatTab[index].img = item.imgOn
      for (let i = 0; i < this.wheatTab.length; i++) {
        if (index != i) {
          this.wheatTab[i].img = this.wheatTab[i].imgObj
        }
      }


    },

  }
}
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/WheatHarvest/index.vue